import React, { useState } from 'react';

import WebsiteNavbar from './lib/html/WebsiteNavbar';
import WebsiteFooter from './lib/html/WebsiteFooter';

import christian from './lib/images/christian-villaran.png';
import alice from './lib/images/alice.png';
import jaime from './lib/images/jaime.png';
import jason from './lib/images/jason.png';
import markus from './lib/images/markus.png';

import '../../css/home_page.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

export default function TeamPage() {
	const [openBioMembers, setOpenBioMembers] = useState([]);

	const handleOpenBioMember = (team_member) => {
		let team_member_index = openBioMembers.findIndex(member => member === team_member);

		if(team_member_index !== -1)
		{
			openBioMembers.splice(team_member_index, 1);
		}
		else{
			openBioMembers.push(team_member);
		}

		setOpenBioMembers([...openBioMembers])
	}

	return (
		<div id='homepage-content'>
			<WebsiteNavbar></WebsiteNavbar>
			<div className='homepage-banner light-gray'>
				<div className='homepage-banner-content padding-mobilize' style={{padding:'0px 140px'}}>
					<h1>Our Team</h1>
					<p id='homepage-team-subheader'>This small team is trying to change the way districts think about their master schedules.</p>
					<div className='homepage-team-container grid-mobilize'>
						<div className='homepage-team-member-container'>
							<div className='homepage-team-member-image'>
								<img src={christian} alt='Christian profile'/>
								<div className='homepage-team-member-description-container'>
									<div className='homepage-team-member-name'>Christian Villaran</div>
									<div className='homepage-team-member-title'>Founder</div>
								</div>
							</div>
							<div className='homepage-team-member-bio-container'>
								<div className='homepage-team-member-bio-btn' onClick={() => handleOpenBioMember('christian')}>
									<div>His story</div>
									<FontAwesomeIcon icon={openBioMembers.includes('christian') ? faChevronUp : faChevronDown}></FontAwesomeIcon>
								</div>
								{(openBioMembers.includes('christian')) &&
									<div className='homepage-team-member-bio'>
										<p>Christian grew up being taught that education is the only way up and out. So when he graduated from Princeton in 2011 he was immediately drawn to the NYC Department of Education as a place where he could do some good.</p> <p>Working as a financial analyst trying to allocate the $20B budget to 1500 schools, he learned quickly that progress wasn't always linear, but also that messy systems still trend towards improvement as long as there are people working towards it.</p>
										<p>Since the DOE, Christian has built Staffs Prep (a college prep business), gotten an MBA from Wharton, and now grown Edario from just an idea, to an app that schedules hundreds of thousands of students every year.</p>
									</div>
								}
							</div>
						</div>
						<div className='homepage-team-member-container'>
							<div className='homepage-team-member-image'>
								<img src={alice} alt='Alice profile'/>
								<div className='homepage-team-member-description-container'>
									<div className='homepage-team-member-name'>Alice Velez</div>
									<div className='homepage-team-member-title'>Scheduling Specialist</div>
								</div>
							</div>
							<div className='homepage-team-member-bio-container'>
								<div className='homepage-team-member-bio-btn' onClick={() => handleOpenBioMember('alice')}>
									<div>Her story</div>
									<FontAwesomeIcon icon={openBioMembers.includes('alice') ? faChevronUp : faChevronDown}></FontAwesomeIcon>
								</div>
								{(openBioMembers.includes('alice')) &&
									<div className='homepage-team-member-bio'>
										<p>Alice is a self-proclaimed master scheduling nerd!  After a successful career as a high school teacher and building administrator, she and her husband founded an educational consultant company, supporting school districts with their very niche skill sets.  One of those skills is master scheduling.</p>
										<p>Master scheduling, traditionally viewed as a technical process, is actually a crucial leadership function for organizing time, staff, and resources to maximize student learning, access, and opportunity.</p>
										<p>Alice works with district and school leaders to develop a sustainable, transparent and equitable master scheduling process that meets the needs of their district.  With two master's degrees in educational leadership and technology, Alice brings practical and theoretical expertise to all her work.</p>
									</div>
								}
							</div>
						</div>
						<div className='homepage-team-member-container'>
							<div className='homepage-team-member-image'>
								<img src={jaime} alt='Jaime profile'/>
								<div className='homepage-team-member-description-container'>
									<div className='homepage-team-member-name'>Jaime Velez</div>
									<div className='homepage-team-member-title'>Edario Associate</div>
								</div>
							</div>
							<div className='homepage-team-member-bio-container'>
								<div className='homepage-team-member-bio-btn' onClick={() => handleOpenBioMember('jaime')}>
									<div>His story</div>
									<FontAwesomeIcon icon={openBioMembers.includes('jaime') ? faChevronUp : faChevronDown}></FontAwesomeIcon>
								</div>
								{(openBioMembers.includes('jaime')) &&
									<div className='homepage-team-member-bio'>
										<p>Jaime's started his career as a data analyst in telecom, but later decided to pursue something more meaningful (than analyzing data for a big telecom company), and joined the education sector. He first pursued consulting work with Booz Allen and Hamilton and then Bellcore, before joining a mid-size school district in New Jersey.</p>
										<p>His technical skills landed him in the technology department. Over the past 22 years, he has worked as an SIS administrator, an auditor, a master scheduler, a state reporting specialist, and a technology instructor.</p>
										<p>With a master's degree in educational leadership and technology, corporate experience, and hands-on data management and analysis skills, Jaime is now introducing Edario, a successful NJ-based scheduling software platform, to the rest of the country.</p>
									</div>
								}
							</div>
						</div>
					</div>
					<div className='homepage-team-container-second grid-mobilize'>
						<div className='homepage-team-member-container'>
							<div className='homepage-team-member-image'>
								<img src={jason} alt='Jason profile'/>
								<div className='homepage-team-member-description-container'>
									<div className='homepage-team-member-name'>Jason Helman</div>
									<div className='homepage-team-member-title'>Head of Technology</div>
								</div>
							</div>
							{/* <div className='homepage-team-member-bio-container'>
								<div className='homepage-team-member-bio-btn' onClick={() => handleOpenBioMember('jason')}>
									<div>His story</div>
									<FontAwesomeIcon icon={openBioMembers.includes('jason') ? faChevronUp : faChevronDown}></FontAwesomeIcon>
								</div>
								{(openBioMembers.includes('jason')) &&
									<div className='homepage-team-member-bio'>
										<p>Christian grew up being taught that education is the only way up and out. So when he graduated from Princeton in 2011 he was immediately drawn to the NYC Department of Education as a place where he could do some good. Working as a financial analyst trying to allocate the $20B budget to 1500 schools, he quickly learned that progress wasn't always linear, but also learned that messy systems still trend towards improvement as long as there are people working towards it. Since the DOE, Christian has built Staffs Prep (a college prep business), gotten an MBA from Wharton, and now grown Edario from just an idea to an app that schedules hundreds of thousands of students every year.</p>
									</div>
								}
							</div> */}
						</div>
						<div className='homepage-team-member-container'>
							<div className='homepage-team-member-image'>
								<img src={markus} alt='Markus profile'/>
								<div className='homepage-team-member-description-container'>
								<div className='homepage-team-member-name'>Markus Ethur</div>
									<div className='homepage-team-member-title'>Senior Developer</div>
								</div>
							</div>
							{/* <div className='homepage-team-member-bio-container'>
								<div className='homepage-team-member-bio-btn' onClick={() => handleOpenBioMember('markus')}>
									<div>His story</div>
									<FontAwesomeIcon icon={openBioMembers.includes('markus') ? faChevronUp : faChevronDown}></FontAwesomeIcon>
								</div>
								{(openBioMembers.includes('markus')) &&
									<div className='homepage-team-member-bio'>
										<p>Christian grew up being taught that education is the only way up and out. So when he graduated from Princeton in 2011 he was immediately drawn to the NYC Department of Education as a place where he could do some good. Working as a financial analyst trying to allocate the $20B budget to 1500 schools, he quickly learned that progress wasn't always linear, but also learned that messy systems still trend towards improvement as long as there are people working towards it. Since the DOE, Christian has built Staffs Prep (a college prep business), gotten an MBA from Wharton, and now grown Edario from just an idea to an app that schedules hundreds of thousands of students every year.</p>
									</div>
								}
							</div> */}
						</div>
					</div>
				</div>
			</div>
			<WebsiteFooter></WebsiteFooter>
		</div>
	);
}